<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
            <ul id="sidebarnav">

                <!-- menú de usuario -->
                <li class="user-profile"
                    [class.active]="userMenuExpanded">
                    <a class="has-arrow waves-effect waves-dark"
                        href="#"
                        (click)="toggleUserMenu($event)"
                        [attr.aria-expanded]="userMenuExpanded">
                        <img [src]="getUserFoto()"
                            alt="usurio" />
                        <span class="hide-menu">{{usuarioSrv.userdata.nombre}} </span>
                    </a>
                    <ul [attr.aria-expanded]="userMenuExpanded"
                        class="collapse"
                        [class.show]="userMenuExpanded">
                        <li><a routerLink="./usr_perfil"
                                routerLinkActive="active">Perfil de usuario</a></li>
                        <li><a href="javascript:void()"
                                class="pointer"
                                (click)="openChangePasswordModal(usuarioSrv.userdata)">Cambiar contraseña</a></li>
                        <li><a routerLink="./config"
                                routerLinkActive="active">App config</a></li>
                        <li><a href="javascript:void()"
                                (click)="logOut()"
                                class="pointer">Desconectar</a></li>
                    </ul>
                </li>
                <li class="nav-devider"></li>
                <li class="nav-small-cap">SGA ENVIALOG</li>

                <!-- menú de opciones -->
                <li *ngFor="let item of sidebarSrv.menu"
                    [class.active]="item.expanded">

                    <a class="has-arrow waves-effect waves-dark"
                        href="#"
                        (click)="toggleMenu(item, $event)"
                        routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{exact: false}"
                        [attr.aria-expanded]="item.expanded">
                        <i [class]="item.icono"></i>
                        <span class="hide-menu">
                            {{item.titulo}}
                        </span>
                    </a>


                    <ul [attr.aria-expanded]="item.expanded"
                        class="collapse"
                        [class.show]="item.expanded">
                        <li *ngFor="let itemSub of item.submenu">
                            <a [routerLink]="itemSub.url"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]={exact:false}>
                                {{itemSub.titulo}}
                                <span *ngIf="sidebarSrv.getNotificaciones(itemSub.url) > 0"
                                    class="badge bg-success ms-2">
                                    {{sidebarSrv.getNotificaciones(itemSub.url)}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </nav>
        <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->